import React, { Component, useDebugValue } from "react";
import {withRouter} from 'react-router-dom';
import moment from "moment";

import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
// import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';


class DashboardActivity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openActivity: this.props.openActivity,
    };
  }

componentDidUpdate(prevProps, prevState) {
  let prev = this.state.openActivity 
  let curr = this.props.openActivity 
  if(curr!=prev){
    this.setState({openActivity: curr})
  }
}

openActivityLog=(bool)=>{
  // this.setState({openActivity:false})
  this.props.openActivityLog(false)
}


activityLogsDetails = (logs) => {
  let details
  let{actionType, document}=logs

  if(actionType==3 ||actionType==4){
  // added to dashboard
    details = `${document.name} from ${document.category}`
  } else if(actionType==2){
  // date range changed
    details = `Dates range was ${moment(document.startDate).format("MMMM D, YYYY")} - ${moment(document.endDate).format("MMMM D, YYYY")}`
  } else if (actionType==1){
  // settings changes
    details=(<span>The following fields were updated:{Object.keys(document).map((key,idx)=> {
    let length = Object.keys(document).length 
      if(idx == length-1){
        return `${key}.` 
      }
      return `${key}, ` 
      })}
      </span>)
  }

  return details
}


renderPerformedBy=(user)=>{
  // console.log('user : ', user)
  let {firstName, lastName} = user.userInfo&&user.userInfo.firstName? user.userInfo: user.updatedBy
  if(firstName && lastName){
    return firstName + ' ' + lastName
  } else if (!lastName){
    return firstName
  }

}

  render() {
    let{ isActivityLog, user, reports}=this.props
    return (
      
        <Modal isOpen={isActivityLog} className="dashboardModalContainer dashboardModalDetailsContainer dashboardModalActivityLogContainer">
        <ModalHeader className="dashboardHeader" charCode="X"
          toggle={()=>this.openActivityLog(false)}
          >
          <div className="dashboardModalTitle"> Activity Log</div>
        </ModalHeader>
              <ModalBody className="dashboardModalBody">
                  <span className="dbActivityLogContainer">
                  <Table responsive hover className="dbActivityLog">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Performed By</th>
                    {/* <th> Updated </th> */}
                    <th> Date </th>
                  </tr>
                </thead>
                <tbody>
                  {reports&& reports.lastUpdate&&reports.lastUpdate.map(e=>{
                     return(
                      <tr className="dbActivityLogRow" key={e._id} >
                        
                        <td >
                          <span className='activityLogType'>{e.data && e.data.type}</span>

                         
                         <div className="activityLogValues">{e.data && e.data.document && Object.keys(e.data.document).length>0? 
                            <span>

                              {this.activityLogsDetails(e.data)}

                              



                            </span>


                             :null
                           }</div>



                        </td>

                        <td >
                          {this.renderPerformedBy(e)}
                        
                        </td>

                        {/* <td>
                           {e.data && e.data.content&&e.data.content.length>0?
                           e.data.content:
                           e.data.document&& Object.keys(e.data.document).length>0? 
                            <span>
                              <div>The following fields were modified:</div>
                              { Object.keys(e.data.document).map((e,idx)=>  `${e}, idx: ${idx} ` ) }
                            </span>
                             :null
                           }
                       
                         </td> */}


                        <td>
                          {moment(e.date).format("MMMM D, YYYY h:mm a")}
                         </td>

                       
                      </tr>
                    )
                  })}
                </tbody>
                </Table>
                  </span>

                  
                </ModalBody>
        </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(DashboardActivity, axios)));

